module.exports = __webpack_public_path__ + "img/horizontal_6_6_5.9e235700.png";